
import React from 'react';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import useArticles from '../../hooks/useArticles';
import useIsArticlesLoaded from '../../hooks/useIsArticlesLoaded';
import IfComp from '../../common/client/components/IfComp';
import AppPageStyle from '../../common/client/components/mysliveckyportal/AppPageStyle';

import useNavigationItems  from '../../hooks/useNavigationItems';
import CheckUserAccountActivation from '../../components/auth/CheckUserAccountActivation';
import ArticleList from '../../components/articles/ArticleList';
import LoginInfo from '../../components/auth/LoginInfo';
import TileContent from '../../components/tiles/TileContent';

const classNames = mergeStyleSets({
    ArticlesPage: {
        padding: 16
    },
});

const ArticlesPage = (props) => {

    const articles = useArticles();
    const isArticlesLoaded = useIsArticlesLoaded();
    const navigationItems = useNavigationItems();

    return (
        <AppPageStyle
            appHeaderContent={<LoginInfo />}
            navigationItems={navigationItems}
            page="articles"
        >
            <CheckUserAccountActivation />
            <Stack className={classNames.ArticlesPage}>
                <IfComp cond={!isArticlesLoaded}>
                    <div>Načítám seznam článků...</div>
                </IfComp>

                <IfComp cond={isArticlesLoaded}>
                    <TileContent title="Seznam článků">
                        <ArticleList articles={articles} />
                    </TileContent>
                </IfComp>
            </Stack>
        </AppPageStyle>
    );
}

export default ArticlesPage;
